import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideoNext = () => {
  return (
    <g>
      <path d="M1.734 0c.134 0 .266.035.38.102l12.533 7.296a.688.688 0 0 1 0 1.204L2.115 15.898a.752.752 0 0 1-1.008-.237.682.682 0 0 1-.107-.365V.704C1 .315 1.329 0 1.734 0zM2.5 2.062v11.875L12.699 8 2.5 2.062z" />
    </g>
  );
};

export default withIcon(IconVideoNext);
